import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { startWith, map } from 'rxjs/operators';
import { ArrayHelper } from '@xanadu/common';

import { SearchComponent } from '../search/search.component';

@Component({
    selector: 'app-autogroup',
    templateUrl: './autogroup.component.html',
    styleUrls: ['./autogroup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutogroupComponent extends SearchComponent {
    protected readonly arrayHelper = input<ArrayHelper>();

	constructor() {
        super();
        effect(() => {
            const formControl = this.formControl();

            if (formControl) {
                const meta = this.meta();
                const items = this.items();

                this.filtered = formControl.valueChanges
                    .pipe(
                        startWith(''),
                        map(value => typeof value === 'string' ? value : meta.display(value)),
                        map(name => name ? this.filterItems(name) : items.slice()),
                        map(array => this.arrayHelper()!.group(array, item => meta.group(item), item => item)),
                        map(object => Object.keys(object).map(key => ({ key: key, items: object[key] })))
                    );
            }
        });
    }
}
